/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3NnsParticipationRate } from "../../funcs/proposalsGetApiV3NnsParticipationRate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NnsParticipationRateRequest$inboundSchema
    .optional(),
};

export const tool$proposalsGetApiV3NnsParticipationRate: ToolDefinition<
  typeof args
> = {
  name: "proposals-get-api-v3-nns-participation-rate",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3NnsParticipationRate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
